import * as AT from './actionTypes'

export const setSecound=(sec)=>{

    return{
        type:AT.SET_SECOUND,
        sec
}

}

export const setOpenDrawer=(open)=>{
    return{
        type:AT.SET_OPEN_DRAWER,
        open
    }
}

export const openCounterModal=(openModal,counterTime)=>{
    return{
        type:AT.OPEN_COUNTER_MODAL,
        openModal,
        counterTime
    }
}

export const setUserInfo=(userInfo)=>{
    return{
        type:AT.SET_USER_INFO,
        userInfo
    }
}

export const setUploaderEmail=(bol)=>{
    return{
        type:AT.SET_IS_UPLOADER_EMAIL,
        bol
    }
}